import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Subscribe } from 'unstated';
import ApplicationContainer from '../../../../shared/state/containers/ApplicationContainer';
import AppliedApplicationTemplateContainer from '../../../../shared/state/containers/AppliedApplicationTemplateContainer';
import OrganizationContainer from '../../../../shared/state/containers/OrganizationContainer';
import ApplicationManagerContent from './ApplicationManagerContent';
import ApplicationEnvironmentsContainer from '../../../../shared/state/containers/ApplicationEnvironmentsContainer';
import ApplicationAnalyticsFacetContainer from '../../../../shared/state/containers/ApplicationAnalyticsFacetContainer';
import TemplateConfigurationContainer from '../../../../shared/state/containers/TemplateConfigurationContainer';
import MediaContainer from '../../../../shared/state/containers/MediaContainer';
import CurrentApplicationContainer from '../../../../shared/hooks/CurrentApplicationContainer';

interface AppliedAppTemplatesManagerProps {
    applicationId: string
    appliedAppTemplateId?: string
}

const ApplicationManager: React.FC<RouteComponentProps<AppliedAppTemplatesManagerProps>> = (props) => {
    // Set current application ID in the container
    const currentAppContainer = CurrentApplicationContainer.useContainer();
    useEffect(() => {
        if (props.match.params.applicationId) {
            currentAppContainer.setApplicationId(props.match.params.applicationId);
        }
    }, [props.match.params.applicationId]);

    return (
        <Subscribe to={[ApplicationContainer, AppliedApplicationTemplateContainer, OrganizationContainer, ApplicationEnvironmentsContainer, ApplicationAnalyticsFacetContainer, TemplateConfigurationContainer, MediaContainer]}>
            {(appContainer: ApplicationContainer,
                appliedAppTemplateContainer: AppliedApplicationTemplateContainer,
                orgContainer: OrganizationContainer,
                applicationEnvironmentsContainer: ApplicationEnvironmentsContainer,
                facetContainer: ApplicationAnalyticsFacetContainer,
                templateConfigContainer: TemplateConfigurationContainer,
                mediaContainer: MediaContainer
            ) => (
                <ApplicationManagerContent
                    appContainer={appContainer}
                    appliedAppTemplateContainer={appliedAppTemplateContainer}
                    orgContainer={orgContainer}
                    applicationId={props.match.params.applicationId}
                    history={props.history}
                    facetContainer={facetContainer}
                    key={props.match.params.appliedAppTemplateId}
                    applicationEnvironmentsContainer={applicationEnvironmentsContainer}
                    templateConfigContainer={templateConfigContainer}
                    appliedAppTemplateId={props.match.params.appliedAppTemplateId}
                    mediaContainer={mediaContainer}
                />
            )}
        </Subscribe>
    )
}

export default ApplicationManager;